<template>
 <div>
   <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
   <v-main>
     <div class="col-md-12 ml-sm-auto col-lg-12 pa-4">
       <v-row>
         <v-col>
           <h2>รายงานแจกผู้ใช้งานใหม่</h2>
         </v-col>
         <v-col
           class="text-right mb-4"
         >
           <v-btn
             class="btn-color"
             v-on="on"
             outlined
             color="indigo"
           >
             <download-excel
               class="btn btn-default text-white"
               :data="dataItem"
               :fields="export_fields"
               :type="exportType"
               :worksheet="exportWorksheet"
               :name="exportFileName"
               style="display: flex"
             >
               <v-icon color="indigo">
                 mdi-download
               </v-icon>
               <p class="mb-0 indigo--text">Export Data</p>
             </download-excel>
           </v-btn>
         </v-col>
       </v-row>

       <v-row class="pb-3 mt-5 ma-0 w-100 col-grid">
         <div class="pa-0">
           <v-menu
               ref="menu"
               v-model="menu"
               :close-on-content-click="false"
               :return-value.sync="date"
               transition="scale-transition"
               offset-y
               min-width="auto"
             >
               <template v-slot:activator="{ on, attrs }">
                 <v-text-field
                   v-model="dateRangeText"
                   label="ค้นหาตามวันที่"
                   prepend-inner-icon="mdi-calendar"
                   readonly
                   outlined
                   dense
                   v-bind="attrs"
                   v-on="on"
                   clearable
                   @click:clear="clearTextField()"
                   hide-details
                 ></v-text-field>
               </template>
               <v-date-picker v-model="date" no-title scrollable range>
                 <v-spacer></v-spacer>
                 <v-btn text color="primary" @click="menu = false">
                   Cancel
                 </v-btn>
                 <v-btn text color="primary" @click="$refs.menu.save(date)">
                   OK
                 </v-btn>
               </v-date-picker>
             </v-menu>
         </div>
         <div class="pa-0">
           <v-text-field
             v-model="memberSearch"
             label="ค้นหา ชื่อ / เบอร์โทร"
             prepend-inner-icon="mdi-magnify"
             outlined
             dense
             clearable
             hide-details
           ></v-text-field>
         </div>
         <v-btn class="btn-grid" color="indigo" dark @click.stop="getData()">ค้นหา</v-btn>
       </v-row>

       <v-card>
           <v-data-table
                 :headers="columns"
                 :items="dataItem"
                 :search="memberSearch"
                 :custom-filter="memberFilter"
                 :items-per-page="10"
                 class="elevation-1"
                 style="padding-top: 10px"
               >
               <template v-slot:[`item.picture`]="{ item }">
                   <v-avatar color="primary" size="40">
                     <img :src="item.picture" alt="img"
                   /></v-avatar>
                 </template>
                 <template v-slot:[`item.CREATE_DATE`]="{ item }">
                  <div>{{ thaiFormattedDateHHmm(item.CREATE_DATE) }}</div>
                 </template>
               </v-data-table>
       </v-card>
     </div>
   </v-main>
 </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx'
import memberSearch from '@/mixins/memberSearch'
export default {
  mixins: [memberSearch],
  components: {
    moment,
    downloadExcel: JsonExcel,
    XLSX
  },
  data () {
    return {
      PK: '',
      returnLink: '/Master/Package',
      session: this.$session.getAll(),
      tab: null,
      dialogPackageMember: false,
      valid: true,
      columns: [
        { text: 'รูปไลน์', value: 'picture' },
        { text: 'ชื่อไลน์', value: 'name' },
        { text: 'ชื่อลูกค้า', value: 'nameCustomer' },
        { text: 'คะแนน', value: 'point' },
        { text: 'เบอร์โทร', value: 'tel' },
        { text: 'วันที่ได้คะแนน', value: 'CREATE_DATE' }
      ],
      export_fields: {
        lineUserId: 'lineUserId',
        ชื่อไลน์: 'name',
        ชื่อลูกค้า: 'nameCustomer',
        'เบอร์โทร': {
          field: 'tel',
          callback: (value) => {
            const telString = value.toString()
            return telString.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
          },
          formatNumber: '@'
        },
        วันเกิด: 'birthDay',
        เพศ: 'gender',
        คะแนน: 'point',
        'วันที่ได้คะแนน': {
          field: 'CREATE_DATE',
          callback: (value) => {
            const formattedValue = value
              ? moment.utc(new Date(value)).format('DD/MM/YYYY HH:mm:ss').toString()
              : null
            if (formattedValue) {
              return moment.utc(formattedValue, 'DD/MM/YYYY HH:mm:ss').add(543, 'years').format('DD/MM/YYYY HH:mm:ss')
            } else {
              return ''
            }
          }
        }
      },
      exportFileName: '',
      dataItem: [],
      on: {},
      exportType: 'application/vnd.ms-excel',
      exportWorksheet: 'Sheet1',
      date: [],
      menu: false,
      startDate: '',
      endDate: ''
    }
  },
  async mounted () {
    this.generateFileName()
    await this.getData()
  },
  computed: {
    dateRangeText: {
      get () {
        return this.date.join(' - ')
      },
      set (value) {
        this.date = value ? value.split(' - ') : []
      }
    }
  },
  methods: {
    generateFileName () {
      const date = moment().format('DDMMYYYY')
      this.exportFileName = ` Report_SpecialPoin_${date}.xls`
    },
    async getData () {
      try {
        this.dataItem = []
        await this.setDate()

        let url = this.DNS_IP + '/Log_SpecialPoint/get?shopId=' + this.session.data.shopId

        if (this.startDate && this.endDate) {
          url += `&CREATE_DATE=${encodeURIComponent(`${this.startDate},${this.endDate}`)}`
        }

        await axios
          .get(
            url
          )
          .then(res => {
            if (res.data.status !== false) {
              this.dataItem = res.data
              console.log('res.data', res.data)
            } else {
              this.dataItem = []
            }
          })
      } catch (error) {
        console.log('error', error)
      }
    },
    setDate () {
      this.startDate = ''
      this.endDate = ''
      if (this.date.length === 2) {
        this.date.sort()
        this.startDate = moment(this.date[0]).format('YYYY-MM-DD')
        this.endDate = moment(this.date[1]).format('YYYY-MM-DD')
      } else if (this.date.length === 1) {
        this.startDate = moment(this.date[0]).format('YYYY-MM-DD')
        this.endDate = moment(this.date[0]).format('YYYY-MM-DD')
      }
    },
    clearTextField () {
      this.date = []
      this.getData()
    }
  }
}
</script>
<style scoped>
h3 {
 font-size: 18.72px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/reportSpecialPoin.vue